import React from 'react';
import './Addmission.css';
import pdf from "../../assets/AMRIT LAW COLLEGE - ADMISSION FORM.pdf";

const Addmission = () => {
  return (
    <section className="admission-section">
      <h2>Download Admission Form</h2>
      <p>
        To apply for admission, please download and complete the admission form.
        Once completed, you can submit it through our online portal or by mail.
      </p>
      <a 
        className="admission-btn"
        href={pdf}
        target="_blank"
        rel="noopener noreferrer"
      >
        Download Admission Form
      </a>
    </section>
  );
};

export default Addmission;
